import type { ModalState } from '../../types';
import { CLOSE_MODAL, OPEN_MODAL } from '../actions';

export function modalReducer(
  state: ModalState = {
    modalComponent: null,
    modalProps: null,
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): ModalState {
  switch (action.type) {
    case OPEN_MODAL:
      return { ...state, ...action.payload };
    case CLOSE_MODAL:
      return {
        modalComponent: null,
        modalProps: null,
      };
    default:
      return state;
  }
}
